
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, FormHelperText, Stack, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import strings from '../Globalization';
import Model from '../models/model';

const washerCIResultLabel = { inputProps: { 'aria-label': strings.CIResult } };
const WasherCIResultInput = ({ inputProps: { column, formik, fieldLabel, field } }) => {
	const theme = useTheme();
	const handleOnChange = val => event => {
		formik.setFieldValue(field, event.target.checked? val : null, true);
	}

	return (
		<Grid container className="inputWrapper">
			<Grid size={12}>
				<Stack
					direction="row"
					sx={{
						'& .MuiCheckbox-root': {
							border: `1px solid ${theme.palette.divider}`,
							mr: 1,
							'&.Mui-checked': { backgroundColor: theme.palette.divider }
						},
						'& .MuiSvgIcon-root': { fontSize: 24 }
					}}
				>
					<Checkbox
						{...washerCIResultLabel}
						checked={formik.values[field] === 1}
						onChange={handleOnChange(1)}
						icon={<CheckIcon color="success" />}
						checkedIcon={<CheckIcon color="success" />}
					/>
					<Checkbox
						{...washerCIResultLabel}
						checked={formik.values[field] === 2}
						onChange={handleOnChange(2)}
						icon={<CloseIcon color="error" />}
						checkedIcon={<CloseIcon color="error" />}
					/>
				</Stack>
			</Grid>
			<Grid size={12}>
				<FormHelperText error={formik.touched[field] && formik.errors[field]}>
					{formik.touched[field] &&
						typeof formik.errors[field] === 'string' && [
							fieldLabel,
							formik.errors[field].replace('{0}', '').replace(field, '')
						]}
				</FormHelperText>
			</Grid>
		</Grid>
	);
}
const model = new Model({
	name: 'Cycle',
	api: 'Cycle',
	title: 'Cycle',
	disableDelete: true,
	showGridRefreshBtn: true,
	initialValues: {
		WasherCILotNumberId: 0,
		WasherCIResult: 1
	},
	customizeSaveData: (toSave, { activeRecord }) => {
		toSave.id = activeRecord.record?.id || activeRecord.record?.Id || activeRecord.record?._id;
		return toSave;
	},
	columns: [
		{ header: 'LotNumber', field: 'WasherCILotNumberId', lookup: 'CleaningIndicator', inputProps: { disablePortal: true } },
		{
			header: 'CIResult',
			field: 'WasherCIResult',
			type: 'boolean',
			required: true,
			customizeInput: WasherCIResultInput
		}
	]
});
export const CIResultForm = model.createFormDialog();
export default model.createFormBase();
